'use client';
import { useState } from 'react';
import { Flex, HStack, Stack, Text, VStack } from '@chakra-ui/react';

import { breakpoints } from 'app/themeConfig';
import SliderControls from 'features/SliderControls';
import { useSwiperControls } from 'shared/hooks';
import BlockHeader from 'shared/BlockHeader';
import NextImage from 'shared/NextImage';
import Slider from 'shared/Slider';

import { partnersPropsSelector } from 'constants/Partners';
import { DEFAULT_BORDER, DEFAULT_BORDER_RADIUS } from 'constants/global';

const gridSetup = { rows: 2, fill: 'row' };

export default function Partners({ type }) {
  const {
    title,
    titleProps = null,
    description,
    descriptionProps = null,
    cardsData,
  } = partnersPropsSelector[type];
  const [swiper, setSwiper] = useState();
  const controls = useSwiperControls(swiper, true);

  return (
    <Stack w="full" align="start" gap={{ laptop: '48px', tablet: '32px', mobile: '24px' }}>
      <HStack w="full" justify="space-between" align="end">
        <VStack
          w="full"
          maxW={{ laptop: '900px' }}
          align="start"
          gap={{ mobile: '16px', laptop: '24px' }}
        >
          <BlockHeader {...titleProps}>{title}</BlockHeader>

          <Text {...descriptionProps}>{description}</Text>
        </VStack>

        <SliderControls {...controls} hideBelow="laptop" />
      </HStack>

      <Slider
        controller={swiper}
        setController={setSwiper}
        slidesData={cardsData}
        SlideComponent={PartnerCard}
        mousewheel={false}
        spaceBetween={8}
        slidesPerView={1}
        grid={gridSetup}
        isBreakpoints={false}
        breakpoints={{
          [parseInt(breakpoints.xm)]: { slidesPerView: 2, spaceBetween: 8, grid: gridSetup },
          [parseInt(breakpoints.tablet)]: { slidesPerView: 3, spaceBetween: 16, grid: gridSetup },
          [parseInt(breakpoints.laptop)]: { slidesPerView: 3, spaceBetween: 20, grid: gridSetup },
        }}
      />
    </Stack>
  );
}

const PartnerCard = cardData => (
  <Flex
    w="full"
    h={{ mobile: '100px', tablet: '170px', laptop: '232px' }}
    border={DEFAULT_BORDER}
    borderRadius={DEFAULT_BORDER_RADIUS}
    borderColor="line.gray"
    bgColor="bg.white"
    p={{ mobile: '18px', tablet: '32px 5px', laptop: '40px 48px' }}
  >
    <NextImage {...cardData} boxSize="full" filter="grayscale(100%)" />
  </Flex>
);
